export type OktaJWT = string & { readonly okta: unique symbol };

export function asOktaToken(token: string) {
  return token as OktaJWT;
}
